import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import generalActions from 'redux/actions/generalActions'
import privateLibraryActions from 'redux/actions/privateLibraryActions'
import SecondaryTitle from 'components/title_secondary/title_secondary'
import Modalizer from 'components/modalizer/modalizer'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import ToggleForm from 'components/toggle/toggle_form'

import { localize } from 'helpers/translator'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import TextInputForm from 'components/input/text/text_input_form'
import { MainButton } from 'components/button'
import { BalloonTooltip } from 'components/tooltip'
import { QuestionIcon } from 'components/icon'

import styles from './private_library_settings_edit.scss'

const gears = <svg height="16" width="16"><path d="M7.81 6C6.81 6 6 6.81 6 7.81s.81 1.81 1.81 1.81 1.81-.81 1.81-1.81S8.81 6 7.81 6" fill="#686868"/><path d="M4.91 8c0-1.71 1.38-3.09 3.09-3.09S11.09 6.29 11.09 8 9.71 11.09 8 11.09 4.91 9.71 4.91 8zm9.17-1.54c-.68-.24-1-1.02-.69-1.67l.5-1.07c.5-1.03-.58-2.11-1.61-1.61l-1.07.5c-.65.31-1.43-.01-1.67-.69L9.14.81c-.38-1.08-1.9-1.08-2.28 0l-.4 1.11c-.24.68-1.02 1-1.67.69l-1.07-.5c-1.03-.5-2.11.58-1.62 1.61l.51 1.07c.31.65-.01 1.43-.69 1.67l-1.11.4c-1.08.38-1.08 1.9 0 2.28l1.11.4c.68.24 1 1.02.69 1.67l-.51 1.07c-.49 1.03.59 2.11 1.62 1.61l1.07-.5c.65-.31 1.43.01 1.67.69l.4 1.11c.38 1.08 1.9 1.08 2.28 0l.4-1.11c.24-.68 1.02-1 1.67-.69l1.07.5c1.03.5 2.11-.58 1.61-1.61l-.5-1.07c-.31-.65.01-1.43.69-1.67l1.11-.4c1.08-.38 1.08-1.9 0-2.28z" fill="#686868"/></svg>

const validate = values => {
	const errors = {}
	if (!values.name) {
		errors.name = localize('global_form_emailIsRequired')
	}
	return errors
}

class PrivateLibrarySettingsModal extends Component {

	getFieldStatus(field) {
		if (field.touched && field.invalid) {
			return 'error'
		} else {
			return ''
		}
	}

	getFieldMessage(field, name) {
		return this.props.login.authenticationFailed ? name === 'password' ? field.error : '' : localize(field.error)
	}

	render() {

		const {
			handleSubmit,
			submitting } = this.props


		const handleLoginSubmit = values => new Promise((resolve, reject) => {
			this.props.actions.submitSettings(values, resolve, reject)
		})

		const title = this.props.library_type === 'school' ? localize('private_library_settings_edit_title') : localize('private_library_settings_district_edit_title')

		return (
			<Modalizer modalName={this.props.modalName} width='336px' closeAction={() => this.props.actions.closeModal(this.props.modalName)}>
				<div>
					{/*
					<h2 styleName='title'>
						<i styleName='title-icon'>
	                        <svg height="16" width="16"> <path d="M7.81 6C6.81 6 6 6.81 6 7.81s.81 1.81 1.81 1.81 1.81-.81 1.81-1.81S8.81 6 7.81 6" fill="#686868"/> <path d="M4.91 8c0-1.71 1.38-3.09 3.09-3.09S11.09 6.29 11.09 8 9.71 11.09 8 11.09 4.91 9.71 4.91 8zm9.17-1.54c-.68-.24-1-1.02-.69-1.67l.5-1.07c.5-1.03-.58-2.11-1.61-1.61l-1.07.5c-.65.31-1.43-.01-1.67-.69L9.14.81c-.38-1.08-1.9-1.08-2.28 0l-.4 1.11c-.24.68-1.02 1-1.67.69l-1.07-.5c-1.03-.5-2.11.58-1.62 1.61l.51 1.07c.31.65-.01 1.43-.69 1.67l-1.11.4c-1.08.38-1.08 1.9 0 2.28l1.11.4c.68.24 1 1.02.69 1.67l-.51 1.07c-.49 1.03.59 2.11 1.62 1.61l1.07-.5c.65-.31 1.43.01 1.67.69l.4 1.11c.38 1.08 1.9 1.08 2.28 0l.4-1.11c.24-.68 1.02-1 1.67-.69l1.07.5c1.03.5 2.11-.58 1.61-1.61l-.5-1.07c-.31-.65.01-1.43.69-1.67l1.11-.4c1.08-.38 1.08-1.9 0-2.28z" fill="#686868"/> </svg>
						</i>
						<span styleName='title-text'>
							{localize('private_library_settings_edit_title')}
						</span>
					</h2>
					*/}
					<SecondaryTitle icon={gears} isCentered={true}>{title}</SecondaryTitle>
					<p styleName='name'>{localize('private_library_settings_edit_name')}</p>

					<form onSubmit={handleSubmit(handleLoginSubmit)}>

						<div className={styles.input}>
							<Field
								name="name"
								component={TextInputForm}
								type="text"
								props={{
									placeholder: localize('private_library_settings_edit_placeholder'),
									disabled: submitting,
									fieldStatus: this.getFieldStatus,
									getMessage: () => localize('private_library_settings_edit_message'),
									onInput: this.resetLoginAuthentication,
									icons: {active: true},
								}}
							/>

							<div styleName='toggle'>
								<p styleName='toggle-text'>
									{this.props.library_type === 'school' ? localize('private_library_settings_edit_toggle') : localize('private_library_settings_edit_toggle_district')}
								</p>
								<div styleName='toggle-area'>
									<Field
										name={'users_can_add'}
										component={ToggleForm}
									/>

								</div>
								<i styleName='toggle-tooltip'>
									<BalloonTooltip tooltip={localize('private_library_settings_edit_toggle_tooltip')} position='right' width='200px'>
										<QuestionIcon />
									</BalloonTooltip>
								</i>
							</div>

							<div styleName='button'>
								<MainButton type="submit">
									{localize('private_library_settings_edit_submit')}
								</MainButton>
							</div>
						</div>

					</form>
				</div>
			</Modalizer>
		)
	}
}

PrivateLibrarySettingsModal.propTypes = {
}

const pp = CSSModules(PrivateLibrarySettingsModal, styles, {allowMultiple: true})

const PrivateLibrarySettingsModalDecoratedForm = reduxForm({
	form: 'PrivateLibrarySettings',
	fields: ['name', 'users_can_add'],
	validate,
})(pp)

function mapStateToProps(state) {
	return {
		initialValues: {
			name: state.libraries.current.settings.name,
			users_can_add: state.libraries.current.settings.users_can_add,
		},
		library_type: state.libraries.current.settings.entity_type,
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
		submitSettings: privateLibraryActions.submitPrivateLibrarySettings,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateLibrarySettingsModalDecoratedForm)
